import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { useVote } from './hooks/useVote';
import { useGetParams } from './hooks/useGetParams';
// import { useBroadcast } from './hooks/useBroadcast';

import { Photos } from './components/Photos/Photos';

import defaultBackground from './assets/images/bg.png';

function App() {
  const { voteState, currentState, messages } = useVote();
  // const { messages, currentState } = useBroadcast();

  const { bg, bgColor, positionAvatars } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && messages?.length !== 0 && (
          <motion.div
            style={{
              justifyContent:
                positionAvatars === '1'
                  ? 'center'
                  : positionAvatars === '2'
                    ? 'flex-end'
                    : 'flex-start',
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            key={'photos'}
            className="motionBlock"
          >
            <Photos messages={messages} />
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader" />
    </div>
  );
}

export default App;
